import { Box, FormControl, FormControlLabel, InputLabel, Select, Switch, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import downlod from '../../assets/aldi/images/DownloadImage.png'
import { ApiGetDataExplorer, ApiGetTrendData } from '../../apiService/Core/Apicall';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import storage from '../../utils/storage';

function DataExplorer() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [month, setMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)

    const downloadtrenddata = async (reportType: string, reportName: string) => {
        const data = `?clientEntityIds=${clientEntityIds}&jobMonth=${month.month() + 1}&jobYear=${month.year()}&clientGroup=JBHIFI${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
        try {
            const res = await ApiGetDataExplorer(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `JBHIFI_DataExplorer_${month.format('MMM')}-${month.format('YY')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        setMonth(dayjs(selectedMonth))
    }, [selectedMonth])


    return (
        <Box>
            <Box className='d-flex flex-wrap-reverse align-items-center justify-content-between mb-2'>
                <Box className='d-flex align-items-center justify-content-end col-12'>
                    {/* {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") === "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                        <Box className='w-100 d-flex justify-content-end mb-2'>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isGroupScore}
                                        onChange={(e) => setisGroupScore(e.target.checked)}
                                    />
                                }
                                label={"Whole Group"}
                            />
                        </Box>)} */}
                    {/* <Box justifyContent={{ xs: 'start', md: 'end' }} border='1px solid red' className='col-5  d-flex align-itmes-center'> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" justifyContent={'end'} width='27%' gap={3}>
                            <DatePicker value={month} className='col-5'
                                label="Month:"
                                views={['month', 'year']}
                                format="MMM-YY"
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </Box>
                    </LocalizationProvider>
                    {/* </Box> */}
                </Box>

            </Box>

            <Box className='d-flex align-items-center  w-100 h-100 gap-3'>
                <Box className='w-50 h-100 border-20 p-3 px-4'>
                    <Box className='bg-main p-2 px-3 mb-3 border-20' >
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>01</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('national_trend_by_questions_complince', 'National-Trend-by-Question-compliance') }}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>National Trend By Question</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default DataExplorer
